import { Button, Col, Row, Spinner } from "react-bootstrap";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import ButtonOverride from "../../../../../components/buttonoverride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from 'react-hook-form';
import React, { useEffect, useState } from "react";
import useTestExpenditureData from "../../../../../testdata/expenditure/testexpenditurestore";
import ReceiptsPanel from "../receipts/receiptspanel";
import FileUpload from "../../../../../components/fileupload";
import { NumericFormat } from "react-number-format";
import { appendFormData } from "../../../../../utilities/formdata";
import useMessageStore from "../../../../../stores/message-store";
import useApi from "../../../../../hooks/use-api";

const ExpenditureCheckAddEdit = ({ApplicationID, checkId = null, returnFunction,refresh,states = [],lineItemCategories = [],expenditureTypes = [],checkTypes = [],sttRttlist = [],userMasterList = [],statusList = [], readOnly = false }) => {
    const [releasedToOptions,setReleasedToOptions] = useState(sttRttlist);

    const checkFormValues = {
        checkrequestamount: null,
        checkrequestdate: '',
        itempurpose: '',
        expendituretypeid: null,
        checktypeid: null,
        vendorname: "",
        vendoraddress: "",
        vendorcity: "",
        vendorstate: -1,
        vendorzip: "",
        vendorphone: "",
        vendornote: "",
        checknumber: '',
        checkamount: null,
        checkdate: '',
        checkreceiveddate: '',
        checkreleasedto: -1,
        checkreleaseddate: '',
        checkreleasenote: '',
        comments: ""
    };


    const { register,control, watch,handleSubmit,setValue,reset, formState: { isSubmitting,errors,isDirty } } = useForm({
        defaultValues: checkFormValues,
        // resolver: yupResolver(schemaObject)
    });

    const [prevFiles, setPrevFiles] = useState([]);
    const [newFiles, setNewFiles] = useState([]);
    const [receiptItems, setReceiptItems] = useState([]);
    
    //Used for tracking to enable or disable submit button if something has changed
    const [initialPrevFiles,setInitialPrevFiles] = useState([]);
    const [initialLineItems,setInitialLineItems] = useState([]);

    const [isLoading,setIsLoading] = useState(() => checkId ? true : false); //Initalize state based on procardId being supplied

    const currentLineItems = watch('lineItems');


    const _mapSelectOptions = (options, zerothLabel) => {
        return [<option key={-1} value={"0"}>{zerothLabel}</option>]
            .concat(options.map((item) => <option key={item.value} value={item.value.toString()}>{item.label}</option>));
    };

    const addToast = useMessageStore(state => state.addToast);
    const {getRequest,postFileRequest,putFileRequest} = useApi();

    const submit = async(values) => {
        const {checkreleasedto,...data} = values;
        
        const sendObject = {
            ...data,
            lineitems: receiptItems,
            existingfiles: prevFiles,
            applicationid: ApplicationID,
            checkid: checkId,
            checkreleasedtouser: checkreleasedto > 0 ? checkreleasedto : null,
            checkreleasedtostatus: checkreleasedto < 0 && checkreleasedto !== -1 ? (-1)*checkreleasedto : null
        }

        if (checkreleasedto === -1) { //Special case when neither is selected
            sendObject.checkreleasedtouser = null;
            sendObject.checkreleasedtostatus = null;
        }
        
        const formData = new FormData();
        
        appendFormData(formData,sendObject);

        for (let index = 0; index < newFiles.length; index++) {
            const element = newFiles[index].file;
  
            formData.append(`newfiles`, element);
        }
        
        if(!checkId){
            const [data,status] = await postFileRequest('ExpenditureWorksheet_Check_Add',formData);

            if(status === 201){
                addToast({
                    id: Math.random(),
                    body: 'Check added successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
                
                refresh();
                returnFunction();
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when adding the Check.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }
        }
        else{
            const [data,status] = await putFileRequest('ExpenditureWorksheet_Check_Update',formData);

            if(status === 200){
                setNewFiles([]);

                const {existingfiles,lineitems,checkreleasedtouser,checkreleasedtostatus,...dataValues} = data;

                let checkreleasedto = null;

                if(checkreleasedtouser !== null){
                    checkreleasedto = checkreleasedtouser;
                }
                else if (checkreleasedtostatus !== null){
                    checkreleasedto = (-1) * checkreleasedtostatus;
                }
                else{
                    checkreleasedto = -1;
                }

                setPrevFiles(existingfiles);
                setReceiptItems(lineitems);

                setInitialLineItems(lineitems);
                setInitialPrevFiles(existingfiles);

                reset({
                    ...dataValues,
                    checkreleasedto: checkreleasedto
                });

                addToast({
                    id: Math.random(),
                    body: 'Check updated successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when updating the Check.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }

            refresh();
        }

    };

    const get = async() => {
        const [data,status] = await getRequest('ExpenditureWorksheet_Check_Get',{checkid : checkId,timestamp: new Date()});

        setIsLoading(false);
        if(status === 200){
            const {existingfiles,lineitems,checkreleasedtouser,checkreleasedtostatus,...dataValues} = data;

            let checkreleasedto = null;

            if(checkreleasedtouser !== null){
                if(!sttRttlist.find(item => item.id === checkreleasedtouser)){
                    const masterRef = userMasterList.find(item => item.id === checkreleasedtouser);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }
                    
                    setReleasedToOptions([inactiveItem,...releasedToOptions]);
                }

                checkreleasedto = checkreleasedtouser;
            }
            else if (checkreleasedtostatus !== null){
                checkreleasedto = (-1) * checkreleasedtostatus;
            }
            else{
                checkreleasedto = -1;
            }

            setPrevFiles(existingfiles);
            setReceiptItems(lineitems);

            setInitialLineItems(lineitems);
            setInitialPrevFiles(existingfiles);

            reset({
                ...dataValues,
                checkreleasedto: checkreleasedto
            });
        }
        else{
            //Handle error gracefully
        }

    }

    useEffect(() => {
        if(checkId){
            get();
        }
        else{
            setPrevFiles([]);
            setReceiptItems([]);
            setNewFiles([]);
        }
    },[])

    const amount = watch('checkamount');
    const releasedtouserid = watch('checkreleasedto');

    const existingFilesChanged = prevFiles.length !== initialPrevFiles.length;
    const existingLineItemsChanged = JSON.stringify(receiptItems) !== JSON.stringify(initialLineItems);
    const mismatchLineItemsAndAmount = !(amount === null && receiptItems.length === 0) ? amount?.toFixed(2) !== receiptItems.reduce((sum,current) => sum + current.amount,0).toFixed(2) : false;
    const releasedToError = releasedtouserid > 0
    ? 
        releasedToOptions.find(item => item.id === releasedtouserid).Inactive 
    : 
        false;

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return (
        <form onSubmit={handleSubmit(submit)} autoComplete="off">
            <div className="clientCard">
                <div className="clientCardInner">
                    <div className={styles.expenditureSubNavContainer}>
                        <ButtonOverride type="button" className={styles.expenditureSubNavBackButton} aria-label="Return" onClick={returnFunction}>
                            <FontAwesomeIcon icon={faCircleArrowLeft} size="2xl" />
                        </ButtonOverride>
                        <h5 className={styles.expenditureSubNavTitle}>
                            {checkId === null ? <>Add Check</> : readOnly ? <>View Check #{checkId}</> : <>Edit Check #{checkId}</>}
                        </h5>
                    </div>
                    <div className={`${styles.addEditForm} mt-4`}>
                        <Row>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <strong>Check Type</strong>
                                        {
                                            checkTypes.map((ct) =>
                                                <div key={ct.id}>
                                                    <label>
                                                        <input type="radio" {...register('checktypeid')} value={ct.id} />
                                                        {ct.name}
                                                    </label>
                                                </div>)
                                        }
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <label htmlFor="checkrequestamount" className="fw-bold">Amount of Check Request</label>
                                        <Controller
                                            name="checkrequestamount"
                                            control={control}
                                            render={({ field }) => (
                                                <NumericFormat 
                                                    value={field.value} 
                                                    id="checkrequestamount" 
                                                    placeholder="Amount" 
                                                    style={{ width: '100%', height: '32px' }} 
                                                    prefix={'$'} 
                                                    decimalScale={2} 
                                                    fixedDecimalScale={true} 
                                                    allowNegative={false}
                                                    onValueChange={(values) => {
                                                        if(values.floatValue === undefined || values.floatValue === null){
                                                            field.onChange(checkFormValues.checkrequestamount); //Reset to default
                                                        }
                                                        else{
                                                            field.onChange(values.floatValue);
                                                        }
                                                    }} 
                                                />
                                            )}
                                        />
                                        <label htmlFor="checkrequestdate" className="fw-bold">Date Check Requested</label>
                                        <input type="date" id="checkrequestdate" {...register('checkrequestdate')} style={{ width: '100%' }} />
                                    </Col>
                                    <Col xs={12}>
                                        <label htmlFor="itempurpose">Item Purpose</label>
                                        <textarea id="itempurpose" {...register('itempurpose')} style={{ width: '100%' }} rows={4} />
                                    </Col>
                                    <Col xs={12}>
                                        <strong>Type of Expenditure</strong>
                                        {
                                            expenditureTypes.map((et) =>
                                                <div key={et.id}>
                                                    <label>
                                                        <input type="radio" {...register('expendituretypeid')} value={et.id} />
                                                        {et.name}
                                                    </label>
                                                </div>)
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={styles.formBox}>
                                    <strong className="d-flex justify-content-center">Vendor Information</strong>
                                    <Row>
                                        <Col xs={12}>
                                            <label htmlFor="vendorname">Vendor Name</label>
                                            <input id="vendorname" type="text" {...register('vendorname')} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <label htmlFor="vendorAddress">Vendor Address</label>
                                            <input id="vendorAddress" type="text" {...register('vendoraddress')} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorPhone">Phone</label>
                                            <input id="vendorPhone" type="tel" {...register('vendorphone')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorCity">City</label>
                                            <input id="vendorCity" type="text" {...register('vendorcity')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorState">State</label>
                                            <Controller
                                                name="vendorstate"
                                                control={control}
                                                render={({field}) => (
                                                    <select {...field} style={{width: '100%',height: '30px'}} id="vendorState" onChange={(e) => {
                                                            field.onChange(parseInt(e.target.value,10))
                                                        }}>
                                                        <option value={-1}>--Select State--</option>
                                                        {
                                                            states.map((state) => (
                                                                <option key={state.id} value={state.id}>{state.name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorZip">Zip</label>
                                            <input type="text" id="vendorZip" {...register('vendorzip')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12}>
                                            <label htmlFor="vendorNote">Vendor Note</label>
                                            <textarea id="vendorNote" {...register('vendornote')} rows={4} style={{ width: '100%' }} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="comments">Comments</label>
                                <textarea id="comments" {...register('comments')} style={{ width: '100%' }} rows={5} />
                            </Col>
                        </Row>
                        <div style={{borderTop: '1px solid black',marginTop: '1rem',marginBottom: '1rem'}}></div>
                        <Row>
                            <Col xs={12} md={6} className="mb-2 d-flex">
                                <div className={styles.formBox}>
                                    <strong className="d-flex justify-content-center">Record Check Receipt Section</strong>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <label htmlFor="checknumber">Check Number</label>
                                            <input id="checknumber" type="text" style={{width: '100%'}} {...register('checknumber')} />
                                        </Col>
                                        <Col xs={12} md={5}>
                                            <label htmlFor="checkdate">Date of Check</label>
                                            <input id="checkdate" type="date" style={{width: '100%'}} {...register('checkdate')}/>
                                        </Col>
                                        <Col xs={12} md={7}>
                                        <label htmlFor="checkamount">Amount of Check</label>
                                        <Controller
                                            name="checkamount"
                                            control={control}
                                            render={({ field }) => (
                                                <NumericFormat 
                                                    value={field.value} 
                                                    id="checkamount" 
                                                    placeholder="Amount" 
                                                    style={{ width: '100%', height: '32px' }} 
                                                    prefix={'$'} 
                                                    decimalScale={2} 
                                                    fixedDecimalScale={true} 
                                                    allowNegative={false}
                                                    onValueChange={(values) => {
                                                        if(values.floatValue === undefined || values.floatValue === null){
                                                            field.onChange(checkFormValues.checkamount); //Reset to default
                                                        }
                                                        else{
                                                            field.onChange(values.floatValue);
                                                        }
                                                    }} 
                                                />
                                            )}
                                        />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={12} md={6} className="mb-2 d-flex">
                                <div className={styles.formBox}>
                                    <strong className="d-flex justify-content-center">MFP Manager Release Check Section</strong>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <label htmlFor="checkreceiveddate">Date Check Received by MFP Mgr</label>
                                            <input type="date" id="checkreceiveddate" style={{width: '100%'}} {...register('checkreceiveddate')}/>
                                        </Col>
                                        <Col xs={12}>
                                            <label htmlFor="checkreleasedto">Check Released To</label>
                                            <Controller
                                                name="checkreleasedto"
                                                control={control}
                                                render={({field}) => (
                                                    <select {...field} style={{width: '100%',color: releasedToError ? 'red' : 'black'}} id="checkreleasedto" onChange={(e) => {
                                                            field.onChange(parseInt(e.target.value,10))
                                                        }}>
                                                        <option value={-1} style={{color: 'black'}}>--Select From List--</option>
                                                        {
                                                            statusList.map((status) => (
                                                                <option key={status.id} value={-status.id} style={{color: 'black'}}>{status.name}</option>
                                                            ))
                                                        }
                                                        {
                                                            releasedToOptions.map((user) => (
                                                                <option key={user.id} value={user.id} style={{color: user.Inactive ? 'red' : 'black'}} disabled={user.Inactive}>{user.name} {user.Inactive ? <>-- No Longer Active</> : null}</option>
                                                            ))
                                                        }
                                                    </select>
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <label htmlFor="checkreleaseddate">Date Check Released</label>
                                            <input type="date" id="checkreleaseddate" style={{width: '100%'}} {...register('checkreleaseddate')}/>
                                        </Col>
                                        <Col xs={12}>
                                            <label htmlFor="checkreleasenote">Check Release Note</label>
                                            <textarea id="checkreleasenote" rows={2} style={{width: '100%'}} {...register('checkreleasenote')} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col xs={12}>
                                <ReceiptsPanel fields={receiptItems} setField={setReceiptItems} lineItemCategories={lineItemCategories} readOnly={readOnly} />
                                {
                                    mismatchLineItemsAndAmount
                                    ?
                                        <div className="d-flex justify-content-end">
                                            <small style={{color: 'red'}}>Check amount and line item totals do not match.</small>
                                        </div>
                                    :
                                        null

                                }
                            </Col>
                            <Col xs={12}>
                                <FileUpload
                                    title="Supporting Documents"
                                    previousFiles={prevFiles}
                                    newFiles={newFiles}
                                    setNewFiles={setNewFiles}
                                    setPrevFiles={setPrevFiles}
                                    FileDownloadData={{CheckID: checkId}}
                                    prevFileDownloadEndpointKey="ExpenditureWorksheet_Check_FileDownload"
                                    readOnly={readOnly}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <Button type="button" variant={readOnly ? "secondary" : "danger"} onClick={returnFunction} disabled={isSubmitting}>{readOnly ? "Return" : "Cancel"}</Button>
                        {
                            !readOnly
                            ?
                                <Button type="submit" variant={checkId !== null ? 'primary' : 'success'} disabled={isSubmitting || (!isDirty && !newFiles.length > 0 && !existingFilesChanged && !existingLineItemsChanged)}>
                                {
                                    !isSubmitting
                                    ?
                                        checkId
                                        ?
                                            <>
                                                <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                                Save Changes
                                            </>
                                        :
                                            <>
                                                <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                                Add Check
                                            </>
                                        :
                                            <Spinner animation='border' size='sm' />
                                }
                                </Button>
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ExpenditureCheckAddEdit;
